import Phaser from "phaser";
import { CST } from "../CST";
import $ from "jquery";
import buttonBehaviours from "../helpers/button-behaviours";
import { hideTextFields, showTextFields } from "../helpers/text-fields";

export default class SendEmail extends Phaser.Scene {
  constructor() {
    super(CST.SCENES.SENDEMAIL);
  }

  preload() {
    this.load.image('bg-send-mail', 'assets/bg-send-mail.png');
    this.load.image('btn-send-mail', 'assets/btn-send-mail.png');
    this.load.image('back_btn', 'assets/english/go-backwards.png');
    this.load.image('error-account-not-found', 'assets/english/error/error-account-not-found.png');
    this.load.image('error-empty-field', 'assets/english/error/error-empty-field.png');
    this.load.image('error-generic', 'assets/english/error/error-generic.png');
    this.load.image('error-invalid-email', 'assets/english/error/error-invalid-email.png');
    this.load.image('message-email-sent', 'assets/english/error/message-email-sent.png');
    this.load.html('html-email', 'html/email.html');
  }

  create() {
    this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "bg-send-mail");

    this.email = this.add
      .dom(this.cameras.main.width / 2 - 95, this.cameras.main.height / 2 - 100)
      .createFromCache("html-email");
    this.email = this.email.getChildByName("email");

    this.btnResetPassword = this.add
      .image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 130, "btn-send-mail")
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, this.btnResetPassword, () => {
          this.sendEmail();
        })
      );

    this.btnBack = this.add
      .image(90, this.cameras.main.height / 2 + 410, "back_btn")
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, this.btnBack, () => {
          this.scene.start(CST.SCENES.LOGIN);
        })
      )
      .setScale(1.5);
  }

  upload() {}

  sendEmail() {
    let self = this;

    $.ajax({
      async: false,
      type: "post",
      url: "website/send-email.php",
      data: {
        email: this.email.value,
      },
      dataType: "JSON",
      success(response) {
        if (response[0] === 400) {
          hideTextFields([self.email]);
          buttonBehaviours.disableInteraction([self.btnResetPassword, self.btnBack]);

          const error = self.add.image(
            self.cameras.main.width / 2,
            self.cameras.main.height / 2 - 175,
            response[1]
          );

          setTimeout(() => {
            showTextFields([self.email]);
            buttonBehaviours.enableInteraction([self.btnResetPassword, self.btnBack]);
            error.destroy();
          }, 2000);
        } else {
          localStorage.setItem("email", self.email.value);
          localStorage.setItem("verificationCode", response[1]);
          hideTextFields([self.email]);
          buttonBehaviours.disableInteraction([self.btnResetPassword, self.btnBack]);
          self.add.image(
            self.cameras.main.width / 2,
            self.cameras.main.height / 2 - 175,
            "message-email-sent"
          );
          setTimeout(() => {
            self.scene.start(CST.SCENES.RESETPASSWORD);
          }, 2000);
        }
      },
      error(error) {
        console.log(error);
      },
    }).responseJSON;
  }
}
